import { useState, useEffect } from "react"
import ErrorMessage from "components/forms/error-message"
import _ from "lodash"
import Label from "components/forms/label"
import Input from "components/forms/input"
import { lang } from "config"
import useBranches from "repositories/branch"

const Form = ({ data = {}, errors = {}, onSubmit }) => {
  const id = data.id ?? undefined

  const [branchId, setBranchId] = useState(data.branch_id ?? "")
  const [bankName, setBankName] = useState(data.bank_name ?? "")
  const [accountName, setAccountName] = useState(data.account_name ?? "")
  const [accountNumber, setAccountNumber] = useState(data.account_number ?? "")
  const [branchName, setBranchName] = useState(data.branch_name ?? "")
  const [notes, setNotes] = useState(data.notes ?? "")
  const [isActive, setIsActive] = useState(
    data.is_active !== undefined && data.is_active !== null ? String(data.is_active) : "1"
  )

  const { data: branches, isLoading: branchesLoading } = useBranches({})

  useEffect(() => {
    setBranchId(data.branch_id ?? "")
    setBankName(data.bank_name ?? "")
    setAccountName(data.account_name ?? "")
    setAccountNumber(data.account_number ?? "")
    setBranchName(data.branch_name ?? "")
    setNotes(data.notes ?? "")
    setIsActive(
      data.is_active !== undefined && data.is_active !== null ? String(data.is_active) : "1"
    )
  }, [data?.id])

  const handleSubmit = (e) => {
    e.preventDefault()

    onSubmit({
      id,
      branch_id: branchId,
      bank_name: bankName,
      account_name: accountName,
      account_number: accountNumber,
      branch_name: branchName,
      notes,
      is_active: Number(isActive),
    })
  }

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <Label htmlFor="branch_id" value={lang.branch} />
          <select
            id="branch_id"
            value={branchId}
            onChange={(e) => setBranchId(e.target.value)}
            className={`${
              errors.branch_id ? "border-red-200" : "border-neutral-200"
            } w-full px-4 py-3 mt-1 text-sm transition border rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200`}
          >
            <option value="">
              {branchesLoading ? "Loading branches..." : `Select ${lang.branch}`}
            </option>

            {(branches?.data ?? []).map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.name}
              </option>
            ))}
          </select>
          <ErrorMessage error={errors.branch_id} />
        </div>

        <div>
          <Label htmlFor="bank_name" value="Bank Name" />
          <Input
            id="bank_name"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            error={errors.bank_name}
          />
          <ErrorMessage error={errors.bank_name} />
        </div>

        <div>
          <Label htmlFor="account_name" value="Account Name" />
          <Input
            id="account_name"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            error={errors.account_name}
          />
          <ErrorMessage error={errors.account_name} />
        </div>

        <div>
          <Label htmlFor="account_number" value="Account Number" />
          <Input
            id="account_number"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            error={errors.account_number}
            type={'number'}
          />
          <ErrorMessage error={errors.account_number} />
        </div>

        {/* <div>
          <Label htmlFor="branch_name" value="Bank Branch" />
          <Input
            id="branch_name"
            value={branchName}
            onChange={(e) => setBranchName(e.target.value)}
            error={errors.branch_name}
          />
          <ErrorMessage error={errors.branch_name} />
        </div> */}

        <div>
          <Label htmlFor="is_active" value="Status" />
          <select
            id="is_active"
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
            className={`${
              errors.is_active ? "border-red-200" : "border-neutral-200"
            } w-full px-4 py-3 mt-1 text-sm transition border rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200`}
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <ErrorMessage error={errors.is_active} />
        </div>

        <div className="sm:col-span-2">
          <Label htmlFor="notes" value="Notes" />
          <textarea
            id="notes"
            name="notes"
            rows="4"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className={`${
              errors.notes ? "border-red-200" : "border-neutral-200"
            } block w-full px-2 py-2 mt-1 text-sm transition border rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200`}
            placeholder="Optional notes"
          />
          <ErrorMessage error={errors.notes} />
        </div>
      </div>

      <div className="text-xs">
        <button
          type="submit"
          className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
        >
          <span>{`${_.isEmpty(data) ? lang.create : lang.update}`}</span>
        </button>
      </div>
    </form>
  )
}

export default Form